"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormats = void 0;
/* eslint-disable import/prefer-default-export */
exports.dateFormats = {
    IL: 'ddd/MMM/yyyy',
    US: 'dd/MM/yyyy',
    SHORT_FORMAT: 'DD/MM/YY',
    LONG_FORMAT: 'dd/MMMM/YYYY',
    SPACED_LONG_FORMAT: 'DD MMMM YYYY',
    SPACED_LONG_FORMAT_COMMA: 'DD MMMM, YYYY'
};
